let dataLog = {
  email: "laboratorio@redsalud.gov.cl",
  password: "secret",
};

export const getTokenSamples = async (resource) => {
  let samples;
  await resource.get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/get_token_tomamuestra/${dataLog.email}/${dataLog.password}`).then(
    (response) => {
      console.log(response.body);
      samples = response.body.token;
    },
    (response) => {
      console.log(response);
    }
  );
  return samples;
};

export const getSamplesByRut = async (resource, rut) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/get_result_patient/${rut}/${window.localStorage.getItem("tokenSamples")}`)
    .then(
      (response) => {
        // success callback
        result = response.body.sample;
        console.log(result);
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};

export const getResult = async (resource, data) => {
  let result;
  await resource
    .get(`api/${window.getApiUrlEntity(localStorage.getItem("perfil"))}patient/get_result_show/${data}/${window.localStorage.getItem("tokenSamples")}`)
    .then(
      (response) => {
        // success callback
        result = response.body.result[0];
      },
      (response) => {
        console.log(response);
        // error callback
      }
    );
  return result;
};
